import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';

import { AppModule } from 'app';
import { environment } from 'environments/environment';
import { LocaleHelper } from 'shared/locale';

import frData from '@angular/common/locales/fr';
import frDataExtra from '@angular/common/locales/extra/fr';

import esData from '@angular/common/locales/es-US';
import esDataExtra from '@angular/common/locales/extra/es-US';

import enData from '@angular/common/locales/en';
import enDataExtra from '@angular/common/locales/extra/en';

import caData from '@angular/common/locales/ca-ES-valencia';
import caDataExtra from '@angular/common/locales/extra/ca-ES-valencia';

import plData from '@angular/common/locales/pl';
import plDataExtra from '@angular/common/locales/extra/pl';

import isData from '@angular/common/locales/is';
import isDataExtra from '@angular/common/locales/extra/is';

import miData from '@angular/common/locales/mi';
import miDataExtra from '@angular/common/locales/extra/mi';

import esSpanishData from '@angular/common/locales/es'; // es-ES
import esSpanishDataExtra from '@angular/common/locales/extra/es'; // es-ES

import svData from '@angular/common/locales/sv'; // sv-SE
import svDataExtra from '@angular/common/locales/extra/sv'; // sv-SE

import nlData from '@angular/common/locales/nl'; // nl-NL
import nlDataExtra from '@angular/common/locales/extra/nl'; // nl-NL

import deData from '@angular/common/locales/de';
import deDataExtra from '@angular/common/locales/extra/de';

import { datadogRum } from '@datadog/browser-rum';

registerLocaleData(frData, 'fr', frDataExtra);
registerLocaleData(esData, 'es-US', esDataExtra);
registerLocaleData(enData, 'en', enDataExtra);
registerLocaleData(caData, 'ca-ES', caDataExtra);
registerLocaleData(plData, 'pl-PL', plDataExtra);
registerLocaleData(isData, 'is-IS', isDataExtra);
registerLocaleData(miData, 'mi-MI', miDataExtra);
registerLocaleData(esSpanishData, 'es-ES', esSpanishDataExtra);
registerLocaleData(svData, 'sv-SE', svDataExtra);
registerLocaleData(nlData, 'nl-NL', nlDataExtra);
registerLocaleData(deData, 'de', deDataExtra);

declare const DD_APP_ID: string | undefined;
declare const DD_CLIENT_TOKEN: string | undefined;
declare const DD_ENV: string | undefined;
declare const DD_RUM_VERSION: string | undefined;

// eslint-disable-next-line no-console
console.log('Running in', environment.production ? 'production' : 'development', 'mode');
if (environment.production) {
  // eslint-disable-next-line no-console
  console.log('Enabling production mode...');
  enableProdMode();
}

const appId = typeof DD_APP_ID !== 'undefined' && DD_APP_ID !== '' ? DD_APP_ID : 'mock-app-id';
const clientToken = typeof DD_CLIENT_TOKEN !== 'undefined' && DD_CLIENT_TOKEN !== '' ? DD_CLIENT_TOKEN : 'mock-client-token';
const env = typeof DD_ENV !== 'undefined' && DD_ENV !== '' ? DD_ENV : 'local';
const version = typeof DD_RUM_VERSION !== 'undefined' && DD_RUM_VERSION !== '' ? DD_RUM_VERSION : '0.0.1';

datadogRum.init({
  applicationId: appId,
  clientToken: clientToken,
  site: 'datadoghq.com',
  service: 'ui-patrons',
  env: env,
  version: version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'mask-user-input'
});

LocaleHelper.getLocaleAndContext()
  .then(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(console.error);
  });
